import useTranslation from 'next-translate/useTranslation'
import get from 'lodash/get'
import ReactTooltip from 'react-tooltip'
import { SelectType } from 'tennders-common/types/SelectType'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'

export type RadioSelectType = SelectType & {
  color ?: string,
  unitClass ?: string
}

type DivProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

type Props = Omit<DivProps, 'onChange'> & {
  form ?: Record<string, any>,
  name ?: string,
  onChange ?: (name: string, value: string|number) => void,
  onSet ?: (value: string|number) => void,
  value?: boolean,
  errors ?: Record<string, any>,
  error ?: string,
  items ?: RadioSelectType[],
  labelClass?: string,
  eClass ?: string,
  label ?: string,
  translate ?: boolean,
  disabled ?: boolean,
  horizontal ?: boolean,
  vertical ?: boolean,
  onlyInput ?: boolean,
  directionClass?: string,
  radioGroupContainerClass? : string
}

const GRadioGroup = ({
  form,
  name,
  onChange,
  onSet,
  items,
  value,
  error,
  errors,
  onlyInput,
  directionClass,
  labelClass,
  eClass,
  label,
  translate,
  disabled,
  horizontal,
  ...rest
} : Props) => {
  const { t } = useTranslation()

  const onFormChange = (e) => {
    if (onSet && e.target.checked) {
      return onSet(e.target.value)
    }
    if (onChange && e.target.checked) {
      onChange(name, e.target.value)
    }
    return false
  }

  const val = form && form[name] !== null ? form[name] : (value)
  const err = errors && errors[name] ? errors[name] : error
  const labelClassName = labelClass || 'form-label'

  const renderInput = () => (
    <>
      <div className={directionClass || `d-flex${horizontal ? ' column' : ' row'}`}>
        {items?.map((item) => (
          <div
            id="radio-group"
            key={item.label + item.value + item.color}
            className={get(item, 'unitClass') ? get(item, 'unitClass') : 'mr-20'}
          >
            <input
              disabled={!!disabled}
              checked={`${val}` === `${item.value}`}
              type="radio"
              id={`radio-${name}`}
              onChange={onFormChange}
              name={name}
              value={item.value}
              className="form-radio"
            />
            <label
              style={{ color: item.color }}
              htmlFor={`radio-${name}`}
            >
              {translate ? t(`variables:${item.label}`) : item.label}
            </label>
          </div>
        ))}
      </div>
      {err
        && (
          <span className="error-text d-flex align-end">
            <FontAwesomeIcon icon={faCircleExclamation} size="lg" className="color-red" data-tip data-for={name} />
            <ReactTooltip id={name} type="error">
              {err}
            </ReactTooltip>
          </span>
        )}
    </>
  )

  return (
    onlyInput
      ? renderInput()
      : (
        <div
          className={eClass || 'mr-24'}
          {...rest}
        >
          {label ? (
            <label
              htmlFor="radio-group"
              id={`radio-${name}`}
              className={labelClassName}
              style={{ color: err ? '#a70c0c' : '' }}
            >
              {label}
            </label>
          ) : null}
          {renderInput()}
        </div>
      )
  )
}

export default GRadioGroup
